import type { CSSProperties } from 'react';

// ─────────────────────────────────────────────────────────────────────────────
// Motion language — "quiet & quick" (Lisa, 2026-06-12).
//
// The reusable motion layer the whole portal inherits. Compositor-only
// (transform/opacity), NO glow, NO border. The CSS lives in index.css as
// `.settle` (staggered entrance that fires on mount and eases to rest) and
// `.morph` (interactive 2D hover/press). Both no-op under
// prefers-reduced-motion.
//
// Usage: add the `SETTLE` class to each item in a group and spread
// `settleDelay(i)` into its style so they cascade in; add `MORPH` to anything
// pressable. Re-mount the container (e.g. a changing React `key`) to replay the
// entrance. Tapestry: ggm-backend/12-portal-design-overhaul.
// ─────────────────────────────────────────────────────────────────────────────

/** Plays the staggered settle entrance. Pair with `settleDelay(i)`. */
export const SETTLE = 'settle';
/** Adds the interactive 2D morph on hover/press (transform only, no glow). */
export const MORPH = 'morph';

const SETTLE_BASE_MS = 50;
const SETTLE_STAGGER_MS = 40;

/** Per-item entrance delay so a group of `.settle` items cascades in order. */
export function settleDelay(index: number): CSSProperties {
  return { animationDelay: `${SETTLE_BASE_MS + index * SETTLE_STAGGER_MS}ms` };
}
